import { Routes as RouterRoutes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClientProvider } from '@tanstack/react-query';
import { PatientProtectedRoute } from '../components/PatientProtectedRoute';
import { Layout } from '../components/Layout';
import { ProtectedResourcePage } from '../components/ProtectedResourcePage';
import { Dashboard } from '../pages/Dashboard';
import { Appointments } from '../pages/Appointments';
import { AppointmentShow } from '../pages/AppointmentShow';
import { PORTAL_RESOURCE_TYPES } from '../constants';
import { queryClient } from '../queryClient';

const ProtectedNavShell = () => (
  <PatientProtectedRoute>
    <Layout>
      <Outlet />
    </Layout>
  </PatientProtectedRoute>
);

// Resource show pages — DOB auth gate shown inline if unauthenticated.
// Add a new entry here to support a new resource type.
const RESOURCE_SHOW_PAGES = [
  { type: PORTAL_RESOURCE_TYPES.APPOINTMENTS, element: <AppointmentShow /> },
];

export function Routes() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <RouterRoutes>
        {RESOURCE_SHOW_PAGES.map(({ type, element }) => (
          <Route
            key={type}
            path={`${type}/:encodedResourceId`}
            element={<ProtectedResourcePage resourceType={type}>{element}</ProtectedResourcePage>}
          />
        ))}

        <Route element={<ProtectedNavShell />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </RouterRoutes>
    </QueryClientProvider>
  );
}
